import basic from '@assets/svg/Badges/arty.svg';
import welcome from '@assets/svg/Badges/welcome.svg';
import friday_the_13 from '@assets/svg/Badges/friday_the_13.svg';
import i_hate_mondays from '@assets/svg/Badges/i_hate_mondays.svg';
import thank_god_its_friday from '@assets/svg/Badges/thank_god_its_friday.svg';
import may_the_4 from '@assets/svg/Badges/may_the_4.svg';
import comeback_kid from '@assets/svg/Badges/comeback_kid.svg';
import perfect_week from '@assets/svg/Badges/perfect_week.svg';
import perfect_month from '@assets/svg/Badges/perfect_month.svg';
import wednesday_warrior from '@assets/svg/Badges/wednesday_warrior.svg';
import april_fool from '@assets/svg/Badges/april_fool.svg';
import valentines_day from '@assets/svg/Badges/valentines_day.svg';
import Pirate_day from '@assets/svg/Badges/pirate_day.svg';
import saint_patrick_day from '@assets/svg/Badges/saint_patrick.svg';
import halloween from '@assets/svg/Badges/halloween.svg';

export default {
    basic,
    welcome,
    friday_the_13,
    i_hate_mondays,
    thank_god_its_friday,
    may_the_4,
    comeback_kid,
    perfect_week,
    perfect_month,
    wednesday_warrior,
    april_fool,
    valentines_day,
    Pirate_day,
    saint_patrick_day,
    halloween
}